import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyC-ZTk4k0yfjNM9-nTZ12il3dp5xfvwN4s",

    authDomain: "royal-rumble-e3a56.firebaseapp.com",

    projectId: "royal-rumble-e3a56",

    storageBucket: "royal-rumble-e3a56.firebasestorage.app",

    messagingSenderId: "646740988482",

    appId: "1:646740988482:web:7ccddf96f19e624b3913db",

    measurementId: "G-YSNR4Q84M7"

};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
